import React, {useEffect, useState} from 'react';
import TextAreaComp from '../../../../components/textArea/textArea';
import DropdownTextComp from '../../../../components/Dropdown/dropDownTextComp';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import makeApiCall from '../../../../api/makeApiCall';
import {
  rejectReasonsCategoryDropdown,
  rejectReasonsSubCatDD,
  leadDropdown,
  loanPurpose,
} from '../../../../api/request/leadApi/leadApi';
import {toast} from 'react-toastify';
import Strings from '../../../../constants/stringConstant';
import LeadStyles from './leadReject.module.css';
import {useTranslation} from 'react-i18next';
import {fetchDashboardType} from '../../../../utils/appUtils';

const LeadReject = ({rejectValue, setRejectValue, onClose, dashboardType}) => {
  const [categoryOption, setCategoryOption] = useState([]);
  const [subCategoryOption, setSubCategoryOption] = useState([]);
  const {t: translator} = useTranslation();

  const {lead} = useSelector(state => state.lead);
  const {loan, applicationType} = useSelector(state => state.loanListPayload);
  const productId = useSelector(state => state.productFilterSlice.productId);

  const isLead = dashboardType === 'Lead';
  useEffect(() => {
    callCategory(applicationType);
  }, []);

  const handleInputChange = event => {
    const {name, value} = event.target;
    setRejectValue(prevState => ({
      ...prevState,
      [name]: value,
    }));

    if (name === Strings.leadManagement.reject_name) {
      callSubCategory(applicationType, value);
    }
  };

  const callCategory = async applicationType => {
    let response;
    if (!applicationType) {
      response = await makeApiCall(
        leadDropdown({
          categoryType: Strings.leadManagement.reject_category,
        }),
      );
    } else {
      response = await makeApiCall(
        rejectReasonsCategoryDropdown({
          stageName: fetchDashboardType(applicationType),
          productId: productId,
          loanApplicationId: loan?.loanApplicationId,
        }),
      );
    }
    if (response?.data?.status === Strings?.success) {
      const data = response?.data?.data;
      setCategoryOption(data);
    } else {
      setCategoryOption([]);
      let errorCode = response?.data?.error?.errorCode;
      let errorMessage = translator(`ErrorMessages.${errorCode}`);

      if (!errorCode || errorMessage === `ErrorMessages.${errorCode}`) {
        errorCode = 'SAMASTA001';
        errorMessage = translator('ErrorMessages.SAMASTA001');
      }

      if (errorCode !== 'SAMASTA015') {
        toast.error(errorMessage);
      }
    }
  };

  const callSubCategory = async (applicationType, selectedValue) => {
    let response;
    if (!applicationType) {
      response = await makeApiCall(
        loanPurpose({
          categoryType: Strings.leadManagement.reject_category,
          category: selectedValue,
        }),
      );
    } else {
      response = await makeApiCall(
        rejectReasonsSubCatDD({
          categoryName: selectedValue,
          stageName: fetchDashboardType(applicationType),
          productId: productId,
          loanApplicationId: loan.loanApplicationId,
        }),
      );
    }
    if (response?.data?.status === Strings?.success) {
      setSubCategoryOption(response?.data?.data);
    } else {
      setSubCategoryOption([]);
      let errorCode = response?.data?.error?.errorCode;
      let errorMessage = translator(`ErrorMessages.${errorCode}`);

      if (!errorCode || errorMessage === `ErrorMessages.${errorCode}`) {
        errorCode = 'SAMASTA001';
        errorMessage = translator('ErrorMessages.SAMASTA001');
      }

      if (errorCode !== 'SAMASTA015') {
        toast.error(errorMessage);
      }
    }
  };

  return (
    <>
      <Grid container className={`text-bold-18px ${LeadStyles.lead_header}`}>
        <Box>{Strings.leadManagement.rejectLead}</Box>

        <IconButton onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </Grid>
      <Box className={`text-400-14px ${LeadStyles.lead_subHeader}`}>
        {Strings.leadManagement.rejectProvideReason}
      </Box>
      <Box className={LeadStyles.leadInfo}>
        <Box className={`text-medium-24px ${LeadStyles.leadInitial}`}>
          {isLead
            ? lead?.contactDetails?.fullName?.substring(0, 1).toUpperCase() ||
              'N'
            : loan?.applicantName?.substring(0, 1).toUpperCase() || 'N'}
        </Box>
        <CardContent className={LeadStyles.leadDetails}>
          <Box className={`text-bold-16px ${LeadStyles.leadName}`}>
            {isLead
              ? lead?.contactDetails?.fullName || 'N/A'
              : loan.applicantName || 'N/A'}
          </Box>
          <Box className={`text-regular-12px ${LeadStyles.leadNumber}`}>
            {isLead
              ? lead?.contactDetails?.mobileNumber || 'N/A'
              : loan.mobileNumber || 'N/A'}
          </Box>
        </CardContent>
      </Box>
      <DropdownTextComp
        label={Strings.leadManagement.reject_dropdown_header}
        name="reasonCategory"
        selectedValue={rejectValue.reasonCategory}
        handleChange={handleInputChange}
        marginTop="24px"
        marginBottom="24px"
        error={''}
        errorMessage={''}
        options={categoryOption}
      />

      <DropdownTextComp
        disabled={!rejectValue.reasonCategory}
        label={Strings.leadManagement.reject_dropdown_subheader}
        name="reasonSubCategory"
        selectedValue={rejectValue.reasonSubCategory}
        handleChange={handleInputChange}
        error={''}
        marginTop="0px"
        marginBottom="24px"
        errorMessage={''}
        options={subCategoryOption}
      />

      <TextAreaComp
        label="Remarks"
        name="remark"
        value={rejectValue.remark}
        onChange={handleInputChange}
        multiline
        fullWidth
        rows={4}
        paddingBottom={3}
        required={true}
      />
    </>
  );
};

LeadReject.propTypes = {
  onClose: PropTypes.any,
  setRejectValue: PropTypes.any,
  rejectValue: PropTypes.any,
  dashboardType: PropTypes.any,
};

export default LeadReject;
